module.exports = __webpack_public_path__ + "img/khp-bot-600w.ea1b13aa.jpg";